import { memo } from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS } from '@contentful/rich-text-types';
import PropTypes from 'prop-types';

const optionsItemsBody = {
	renderNode: {
		[BLOCKS.PARAGRAPH]: (node) =>
			node.content.map((item, index) => (
				<p key={index} className="cc-drawer__breadcrumb-hidden-item-body">
					{item.value}
				</p>
			)),
	},
};

const _Drawer = ({ title, options, show }) => {
	return (
		<section
			aria-expanded={show}
			className={`cc-drawer cc-drawer--desktop ${show ? 'cc-drawer--show' : ''}`}
		>
			<div className="cc-drawer__breadcrumb-hidden">
				<h2 className="cc-drawer__breadcrumb-hidden-title">{title}</h2>
				{options.map(({ cta, title, description }) => (
					<div key={cta.link} className="cc-drawer__breadcrumb-hidden-item">
						<h3 className="cc-drawer__breadcrumb-hidden-item-title">
							{title}
						</h3>
						<div>{renderRichText(description, optionsItemsBody)}</div>
						<Link
							className="cc-drawer__breadcrumb-hidden-item-link"
							tabIndex="0"
							to={cta.link}
						>
							{cta.title}
						</Link>
					</div>
				))}
			</div>
		</section>
	);
};

_Drawer.propTypes = {
	title: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			cta: PropTypes.shape({
				title: PropTypes.string.isRequired,
				link: PropTypes.string.isRequired,
			}),
			title: PropTypes.string.isRequired,
			description: PropTypes.shape({
				raw: PropTypes.string.isRequired,
			}).isRequired,
		})
	).isRequired,
	show: PropTypes.bool,
};

_Drawer.defaultProps = {
	show: false,
};

const Drawer = memo(_Drawer);

export default Drawer;
